import styled from 'styled-components'

export const ValidationDiv = styled.div`
	padding: 5px;
	color: white;
`